import { apiClient } from '../../../client'
import endpoints from '../../../endpoints'
import { unwrapPaginated, type Paginated } from '../../../normalize'
import type {
  FarmQuantificationUnit,
  FarmQuantificationUnitsParams,
  UnassignedPaddock,
} from '../../../../../types/apiModels'

export type FarmQuantificationUnitsMeta = {
  hasPlan: boolean
  unassignedPaddocks: UnassignedPaddock[]
}

export default async function getFarmQuantificationUnits({
  farmId,
  params,
  signal,
}: {
  farmId: string
  params: FarmQuantificationUnitsParams
  signal?: AbortSignal
}): Promise<Paginated<FarmQuantificationUnit, FarmQuantificationUnitsMeta>> {
  const response = await apiClient.get(endpoints.v2.farms.quantificationUnits(farmId), {
    params,
    signal,
  })
  return unwrapPaginated<FarmQuantificationUnit, FarmQuantificationUnitsMeta>(response)
}
